import {Component, type ErrorInfo, type ReactNode} from 'react';
import {analytics} from '../../services/analytics';

// Education is optional UI layered over the clinical workspace. A malformed
// catalog, media card, or modal must never trip the app-wide error boundary
// and block Home, encounters, or notes.
export default class UniversitySafetyBoundary extends Component<
  {children: ReactNode},
  {hasError: boolean}
> {
  state = {hasError: false};

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    try {
      analytics.capture('university_render_error', {
        error_message: error?.message || String(error),
        component_stack: info.componentStack?.slice(0, 1000),
        path: window.location.pathname,
      });
    } catch {
      /* best-effort telemetry */
    }
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
